/* eslint-disable react/prop-types */
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputLabel,
  Stack,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material'
import React, { memo, useCallback, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { MAX_IMAGE_SIZE_BYTES, MAX_IMAGE_SIZE_MB } from '../../../Products/components/Dropzone'
import { DeleteOutline } from '@mui/icons-material'

const UploadImagen: React.FC<{ img: string; setImg: (img: string) => void }> = ({ img, setImg }) => {
  const [dropError, setDropError] = useState<string>()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const onDrop = useCallback((acceptedFiles: File[], rejectedFiles: any[]) => {
    setDropError(undefined)

    if (rejectedFiles && rejectedFiles.length > 0) {
      rejectedFiles.forEach((file: any) => {
        file.errors.forEach((err: any) => {
          if (err.code === 'file-invalid-type') setDropError('Solamente podés subir archivos JPG, JPEG o PNG')
          else setDropError('Error desconocido')
        })
      })
      return
    }

    const file = acceptedFiles[0]
    if (!file) return

    if (file.size > MAX_IMAGE_SIZE_BYTES) {
      setDropError(`El tamaño máximo de la imagen es de ${MAX_IMAGE_SIZE_MB}MB`)
      return
    }

    const reader = new FileReader()
    reader.onloadend = () => setImg(reader.result as string)
    reader.readAsDataURL(file)
  }, [])

  const {
    getRootProps,
    getInputProps,
    open: openFiles,
    isDragActive
  } = useDropzone({
    onDrop,
    noClick: true,
    noKeyboard: true,
    accept: {
      'image/jpeg': [],
      'image/png': [],
      'image/jpg': []
    },
    maxFiles: 1
  })

  return (
    <>
      <Stack sx={{ width: '100%' }} spacing={1}>
        {/* Dropzone */}
        <Box
          {...getRootProps()}
          sx={{
            border: '2px dashed #aaa',
            borderRadius: 2,
            p: img ? 0 : 3,
            textAlign: 'center',
            cursor: 'pointer',
            bgcolor: isDragActive ? 'action.hover' : 'transparent',
            display: 'inline-block'
          }}
        >
          <input {...getInputProps()} />

          {!img ? (
            <>
              {isMobile ? (
                <Typography onClick={() => openFiles()}>Tocá para seleccionar</Typography>
              ) : (
                <Typography onClick={() => openFiles()}>
                  {isDragActive ? 'Soltá la foto aquí...' : 'Arrastrá una foto o hacé click para seleccionar'}
                </Typography>
              )}
            </>
          ) : (
            <>
              <Box sx={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                <img
                  src={img}
                  alt="foto"
                  style={{
                    maxWidth: '100%',
                    display: 'block',
                    borderRadius: '8px'
                  }}
                />
                {/* Botón para eliminar la imagen */}
                <IconButton
                  onClick={() => setImg(null)}
                  sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    bgcolor: 'rgba(0,0,0,0.5)',
                    color: 'white',
                    '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
                  }}
                >
                  <DeleteOutline />
                </IconButton>
              </Box>
            </>
          )}
        </Box>
      </Stack>
      {dropError !== undefined && (
        <Dialog open={dropError !== undefined} onClose={() => setDropError(undefined)} maxWidth="lg">
          <DialogTitle>Errores en la subida de imagenes</DialogTitle>
          <DialogContent>{dropError}</DialogContent>
          <DialogActions>
            <Button onClick={() => setDropError(undefined)}>Cerrar</Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  )
}

export default memo(UploadImagen)
